import {AuditDataVideoAssetsBody} from '@dms/api/core';

import type {AuditDataAssetsBody} from './AuditDataAssetsBody';
import type {ResponseAuditDataFieldsBody} from './ResponseAuditDataFieldsBody';

export type LoadAuditDataCategories = {
  id: string;
  fields: Array<ResponseAuditDataFieldsBody>;
  assets: Array<AuditDataAssetsBody>;
  videoAssets: Array<AuditDataVideoAssetsBody>;
};
